import FloatingTooltip from '#components/tooltip.jsx';
import { formatReadableDateAndHours } from '#helpers/helpers.js';
import { addClasses, cn } from '#lib/helpers/class.js';
import { useContext } from 'react';
import { CoverPlaceholder } from './placeholder.jsx';
import CoverPreview from './preview.jsx';
import { Etcetera, SelectedTag } from './tag.jsx';
import { UserContext } from '#src/index.jsx';
import ImagePreview from '#components/images/image-preview.jsx';

const omit = ['tasks', 'feedbacks'];

export function Card(props) {
    const { name, cover, tags, flattedTags, data } = props;
    const existingTags = tags.reduce((acc, curr) => {
        const tag = flattedTags.find((ft) => ft.id === curr);
        if (tag) acc.push(tag);
        return acc;
    }, []);

    const filterFn = (entry) => {
        const [key, value] = entry;
        if (!omit.includes(key)) return entry;
    };

    const { getLanguage } = useContext(UserContext);
    const intlLang = getLanguage();

    return (
        <div className="relative w-full flex gap-2 p-2 border border-neutral-100 rounded-lg shadow-md hover:bg-neutral-50 hover:scale-[1.01] transition-all">
            {cover ? (
                <div className="w-[160px] h-[90px] hidden 2xl:block rounded-xl overflow-hidden">
                    <ImagePreview imageSrc={cover.src} initialState={cover.coords} alt={cover?.alt} />
                </div>
            ) : (
                <CoverPlaceholder className={addClasses('w-[160px] h-[90px] hidden 2xl:flex rounded-xl')} />
            )}

            <div className={cn("w-full flex flex-col gap-2", (existingTags.length > 0) ? '2xl:gap-2' : '2xl:gap-0')}>
                {(cover || existingTags.length > 0) && <div className="flex justify-between gap-2">
                    {cover ? (
                        <div className="w-[160px] h-[90px] 2xl:hidden rounded-xl overflow-hidden">
                            <ImagePreview imageSrc={cover.src} initialState={cover.coords} alt={cover?.alt} />
                        </div>
                    ) : (
                        <CoverPlaceholder width={160} height={90} className={addClasses('2xl:hidden rounded-xl')} />
                    )}
                    <div className="h-1/4 flex flex-col items-end gap-2 2xl:contents">
                        <h2 className="text-lg text-right font-semibold text-neutral-800">{name}</h2>
                        <ul className="flex gap-2">
                            {existingTags.length < 3 ? (
                                existingTags.map((tag) => {
                                    return <SelectedTag key={tag.id} tag={tag} />;
                                })
                            ) : (
                                <>
                                    {existingTags.slice(0, 1).map((tag) => {
                                        return <SelectedTag key={tag.id} tag={tag} />;
                                    })}
                                    <FloatingTooltip
                                        content={
                                            <div className="flex flex-col gap-1">
                                                {existingTags.slice(1).map((tag) => {
                                                    if (name)
                                                        return (
                                                            <p key={tag.id} className="text-sm font-semibold">
                                                                {tag.name}
                                                            </p>
                                                        );
                                                })}
                                            </div>
                                        }
                                        placement="top"
                                    >
                                        <Etcetera />
                                    </FloatingTooltip>
                                </>
                            )}
                        </ul>
                    </div>
                </div>}
                <div className='grid grid-cols-2 gap-2 md:grid-cols-7 h-full'>
                    {Object.entries(data)
                        .filter(filterFn)
                        .map(([key, value]) => (
                            <div
                                key={key}
                                className="flex flex-col items-center bg-white border p-2 rounded-lg shadow-sm overflow-hidden"
                            >
                                <span className="w-full text-sm text-neutral-500 whitespace-nowrap text-ellipsis truncate">
                                    {_t.edit.fields?.[key]()}
                                </span>
                                <span
                                    className={cn(
                                        'w-full font-semibold text-sm',
                                        !!String(value) ? 'text-neutral-700' : 'text-neutral-500 italic',
                                        existingTags.length > 0 ? 'whitespace-nowrap text-ellipsis truncate' : 'line-clamp-3'
                                    )}
                                >
                                    {key === 'lastPublication'
                                        ? formatReadableDateAndHours(value, intlLang)
                                        : String(value) || _t.search.undefined()}
                                </span>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
}
